import config from '@epi-config';
import { get } from '@epi-helpers/FetchHelpers';
import { BalanceCorrectionsResponse } from '@epi-models/pages/Reports';
import { TRANSACTIONS_PAGE_SIZE } from '@epi-api/constants';

export const getBalanceCorrectionsCheckRequest = (
  abortController: AbortController | null = null
): Promise<boolean> => {
  return get<boolean>(
    `${config.apiHost}/api/company-accounts/balance-corrections/check`,
    undefined,
    undefined,
    abortController?.signal
  );
};

export const getBalanceCorrectionsRequest = (
  page: number,
  from: string,
  to: string,
  abortController: AbortController | null = null
): Promise<BalanceCorrectionsResponse> => {
  return get(
    `${config.apiHost}/api/company-accounts/balance-corrections?Page=${page}&RowsPerPage=${TRANSACTIONS_PAGE_SIZE}&From=${from}&To=${to}`,
    undefined,
    undefined,
    abortController?.signal
  );
};
